import api from './api';

export const searchService = {
  /**
   * Search for a customer by account number.
   */
  searchByAccount: async (accountId) => {
    const response = await api.get(`/customer-search/account/${accountId}`);
    return response.data;
  },

  /**
   * Search for customers by premise address.
   */
  searchByPremise: async (state, city, houseNumber, street) => {
    const response = await api.post('/customer-search/premise', {
      state,
      city,
      houseNumber,
      street,
    });
    return response.data;
  },

  /**
   * Get detailed customer information.
   */
  getCustomerDetail: async (accountId) => {
    const response = await api.get(`/customer-search/customer/${accountId}`);
    return response.data;
  },

  /**
   * Get list of available states.
   */
  getStates: async () => {
    const response = await api.get('/customer-search/states');
    return response.data;
  },

  /**
   * Get list of cities for a given state.
   */
  getCities: async (stateCode) => {
    const response = await api.get(`/customer-search/cities/${stateCode}`);
    return response.data;
  },

  /**
   * Get billing statements for a customer.
   */
  getBills: async (accountId) => {
    const response = await api.get(`/customer-search/bills/${accountId}`);
    return response.data;
  },

  /**
   * Get usage history for the current customer in session.
   */
  getUsageHistory: async () => {
    const response = await api.get('/customer-search/usage-history');
    return response.data;
  },
};